<template>
	<div class="form-group flex flex-col">
		<label class="w-full" v-if="label">
			{{ label }}
			<span v-if="required && !disabled" class="text-red-600 font-bold"> *</span>
		</label>
		<div
			class="flex flex-row border rounded border-gray-400 justify-center bg-white"
			style="min-height: 43px; text-align: center; align-items: center"
		>
			<v-date-picker
				v-if="!disabled"
				:mode="mode"
				v-model="datePickerDate"
				:masks="{ input: ['DD.MM.YYYY', 'DD.MM.YY', 'YYYY', 'DD.MM', 'DD'] }"
				:rows="rows"
				:columns="columns"
				:max-date="max_date"
				:popover="popover"
				@input="changedDate"
				:min-date="min_date"
				:input-props="{
					placeholder: placeholder || label,
					readonly: isAppContainer,
				}"
			>
				<div>
					<font-awesome-icon :icon="['fas', 'calendar']" class="w-5 h-5 ml-2 mr-2 cursor-pointer" size="lg" />
				</div>
			</v-date-picker>
			<the-mask
				type="tel"
				ref="datepicker"
				@blur.native="finishedEditing"
				class="flex flex-grow"
				style="min-height: 43px; outline: none; border: none; box-shadow: none"
				v-model="textDate"
				@change="$emit('change', $event)"
				:disabled="disabled"
				:placeholder="placeholder || label"
				:tokens="hexTokens"
				:mask="getMask()"
			/>
			<div v-if="model && showRemove">
				<font-awesome-icon :icon="['fas', 'trash']" class="w-5 h-5 ml-2 mr-2 cursor-pointer" @click="removeInput" size="lg" />
			</div>
		</div>
		<div class="input-errors" v-if="!isValid && !disabled">{{ label }} ist ein Pflichtfeld</div>
	</div>
</template>

<script>
import { getStringFromDate, parseGermanDate } from '@/plugins/Utils';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import { TheMask } from 'vue-the-mask';
import Validate from '@/mixins/Validate';
export default {
	name: 'BaseDatepicker',
	components: { TheMask },
	mixins: [AppContainerMixin, Validate],
	inheritAttrs: false,
	props: {
		label: {},
		required: {},
		value: {},
		disabled: {},
		mode: { default: 'single' },
		rows: { default: 1 },
		columns: { default: 1 },
		placeholder: {},
		popover: { required: false },
		max_date: {},
		min_date: {},
		filterOnly: { default: false },
		showRemove: { default: false, required: false },
	},
	computed: {
		model: {
			get() {
				if (this.mode === 'range' && this.datePickerDate != null) {
					return getStringFromDate(this.datePickerDate.start) + '-' + getStringFromDate(this.datePickerDate.end);
				}

				return getStringFromDate(this.datePickerDate);
			},
			set(v) {
				if (!this.filterOnly) {
					this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
				}
				this.$emit('input', v);
			},
		},
	},
	data() {
		return {
			isValid: true,
			textDate: '',
			datePickerDate: null,
			hexTokens: {
				N: {
					// NUMBER
					pattern: /[0-9]/,
				},
			},
		};
	},
	methods: {
		removeInput() {
			this.model = null;
		},
		getMask() {
			let msk = ['NN.NN.NNNN', 'NN.NN.NN'];
			if (this.mode === 'range') {
				msk = ['NN.NN.NNNN - NN.NN.NNNN', 'NN.NN.NN - NN.NN.NN'];
			}
			return msk;
		},
		validate() {
			this.isValid = !!this.textDate;
			return this.isValid;
		},
		parseDate($date) {
			const stringLength = $date.length;
			if (stringLength === 8) {
				const year = $date.substring(stringLength - 4, stringLength);
				const month = $date.substring(stringLength - 6, stringLength - 4);
				const day = $date.substring(stringLength - 8, stringLength - 6);
				return day + '.' + month + '.' + year;
			} else if (stringLength === 6) {
				let year = $date.substring(stringLength - 2, stringLength);
				if (year > 40) {
					year = '19' + year;
				}
				const month = $date.substring(stringLength - 4, stringLength - 2);
				const day = $date.substring(stringLength - 6, stringLength - 4);
				return day + '.' + month + '.' + year;
			} else return $date;
		},
		finishedEditing() {
			this.validate();
			if (this.textDate) {
				if (this.mode === 'range') {
					const start = this.textDate.substring(0, 8);
					const end = this.textDate.substring(8, 16);
					this.datePickerDate = { start: new Date(parseGermanDate(this.parseDate(start))), end: new Date(parseGermanDate(this.parseDate(end))) };
				} else {
					this.datePickerDate = new Date(parseGermanDate(this.parseDate(this.textDate)));
				}
				this.model = this.datePickerDate;
			}
		},
		changedDate() {
			this.textDate = this.model;
			this.model = this.datePickerDate;
		},
	},
	mounted() {
		this.datePickerDate = this.value;
		this.textDate = this.model;
	},
	watch: {
		datePickerDate: function(newValue) {
			this.textDate = this.model;
		},
		value: function() {
			this.datePickerDate = this.value;
		},
		textDate: function(newValue) {
			if (!newValue) {
				this.datePickerDate = null;
			} else {
				this.validate();
			}
		},
	},
};
</script>

<style lang="sass">
.pointer-events-none > input
  background: #e9ecef



.vc-py-2
	padding-top: 10px
	padding-bottom: 10px
</style>
